// "Copy review request" (OVERNIGHT-2026-09-28 item 9).
//
// The recruiter copies this and sends it PERSONALLY, from their own phone or email.
// Nothing here sends anything.
//
// THE RULES THIS MODULE EXISTS TO HOLD (review-platform and FTC endorsement rules):
//   1. IDENTICAL, NEUTRAL WORDING FOR EVERYONE. The text takes no candidate input at
//      all -- no name, no outcome, no mood -- so it cannot be tuned to the people
//      expected to be happy. Asking for "an honest review, good or bad" is the point.
//   2. NO INCENTIVE. No gift card, bonus, entry, discount or "thank-you" of value.
//   3. ONLY REAL, CONFIGURED LINKS. Facebook, Indeed and Glassdoor are ProTherapy's own
//      review pages (tools/reports/RATINGS-GATHER-2026-09-26.md, sites repo). Google has
//      no review URL yet, so its line is HIDDEN until REACT_APP_GOOGLE_REVIEW_URL is set
//      to a real https URL -- a placeholder link would send people nowhere.
//
// reviewRequest.test.js pins all three, in both directions.

export const REVIEW_LINKS = [
  { site: 'Facebook', url: 'https://www.facebook.com/protherapystaffing/reviews' },
  { site: 'Indeed', url: 'https://www.indeed.com/cmp/Protherapy-Staffing/reviews' },
  { site: 'Glassdoor', url: 'https://www.glassdoor.com/Reviews/ProTherapy-Staffing-Reviews-E1330505.htm' },
];

/** A configured Google review URL, or null. Only a real https URL counts. */
export function googleReviewUrl(env = process.env) {
  const v = String((env && env.REACT_APP_GOOGLE_REVIEW_URL) || '').trim();
  return /^https:\/\/\S+$/.test(v) ? v : null;
}

/** The links to offer, in order. Google is appended only when configured. */
export function reviewLinks(env = process.env) {
  const g = googleReviewUrl(env);
  return g ? [...REVIEW_LINKS, { site: 'Google', url: g }] : [...REVIEW_LINKS];
}

/**
 * The one message. Deliberately takes NO candidate argument (rule 1): every
 * recipient gets byte-identical text for a given configuration.
 */
export function reviewRequestText(env = process.env) {
  const lines = reviewLinks(env).map((l) => `${l.site}: ${l.url}`);
  return [
    'Thank you for working with ProTherapy Staffing.',
    "If you're willing, we'd appreciate an honest review of your experience, good or bad, on any of these sites:",
    '',
    ...lines,
    '',
    "It's completely optional. Thank you.",
  ].join('\n');
}
